import Model from './Model';

export default class extends Model {
  save(media) {
    if (media.id) {
      return this.patchPromise(`/media/${media.id}`, media);
    }
    return this.postPromise('/media', media);
  }

  delete(id) {
    return this.deletePromise(`/media/${id}`);
  }
}
